import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';
import slugify from 'dibs-slugify/exports/slugify.ts';
import { HeroBannerItem } from '../../nftExhibition/components/HeroBanner/HeroBannerItem.tsx';

import styles from './styles/NftExhibitionsGrid.scss';

import { type NftExhibitionsGrid_viewer$key } from './__generated__/NftExhibitionsGrid_viewer.graphql.ts';

type Props = {
    viewer: NftExhibitionsGrid_viewer$key | null | undefined;
};

export const NftExhibitionsGrid: FC<Props> = ({ viewer: viewerRef }) => {
    const viewer = useFragment(
        graphql`
            fragment NftExhibitionsGrid_viewer on Viewer {
                cmsNftExhibitionPages {
                    pageId
                    pageName
                    modules {
                        heroBanner {
                            bannerConfig {
                                ... on NftCmsExhibitionHtmlBannerType {
                                    startDate
                                }
                            }
                            ...HeroBannerItem_heroBannerItemExhibition
                        }
                    }
                }
            }
        `,
        viewerRef
    );

    const { cmsNftExhibitionPages } = viewer || {};

    const exhibitionTiles = cmsNftExhibitionPages
        ?.slice()
        .sort((a, b) => {
            const dateAStart = a?.modules?.heroBanner?.[0]?.bannerConfig?.startDate;
            const dateBStart = b?.modules?.heroBanner?.[0]?.bannerConfig?.startDate;
            const dateLeft = dateBStart ? new Date(dateBStart) : new Date(1);
            const dateRight = dateAStart ? new Date(dateAStart) : new Date(1);
            return dateLeft.getTime() - dateRight.getTime();
        })
        .map((exhibition, i) => {
            const href = `/nft-collections/exhibitions/${slugify(exhibition?.pageName)}`;
            return (
                <li
                    className={classnames(styles.gridItem, styles.exhibitionItem)}
                    key={`exhibition-${i}`}
                >
                    <HeroBannerItem
                        index={i}
                        inViewport
                        isVisible
                        heroBannerItemExhibition={exhibition?.modules?.heroBanner?.[0] || null}
                        isTile
                        tileHref={href}
                        tileHeader={null}
                    />
                </li>
            );
        });

    return (
        <div className={styles.container}>
            <ul className={styles.grid}>{exhibitionTiles}</ul>
        </div>
    );
};
